import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationManagementService {
  private http = inject(HttpClient);


  getkeyValueList(skip: any, limit: any, isHome: any) {
    return this.http.get(environment.apiUrl + 'notification/list?$skip=' + skip + '&$limit=10' + '&isHome=' + isHome)
  }

  public saveNotification(scope: any,id: any) {
    if(id==null)
      return this.http.post(environment.apiUrl + 'save/notification-management', scope);
    else
      return this.http.post(environment.apiUrl + 'save/notification-management/', scope);
  }

  public archiveNotification(id: any) {
    return this.http.put(environment.apiUrl + 'archive/notification-management/' + id, {});
  }
  
  getNotifications() {
    return this.http.get(environment.apiUrl + 'current/notifications')
  }
  
  updateNotification(notifications: any) {
    return this.http.put(environment.apiUrl + 'user/update/notifications' , { "notifications" : notifications})
  }
  deleteAllNotification(){
    return this.http.put(environment.apiUrl + 'user/delete/all/notifications', {})
  }
}
